import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { TextReveal } from '../PageTransition';
import { NepaleseFrame } from './WoodenFrames';

const ChefSection = () => {
  const { t } = useTranslation();
  
  return (
    <section className="relative py-24 md:py-32 bg-[#F5F3EF]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-2 gap-12 md:gap-20 items-center">
          <NepaleseFrame src="https://customer-assets.emergentagent.com/job_87e498ce-d096-43cf-96be-abf06e8008e0/artifacts/bjjdislo_FB_IMG_1770403668735.jpg" alt="Our Chef in Action" className="max-w-md mx-auto" />
          <div className="space-y-6">
            <TextReveal><p className="text-[#6B705C] text-xs tracking-[0.3em] uppercase">{t('chef.subtitle')}</p></TextReveal>
            <TextReveal delay={0.1}>
              <h2 className="text-4xl md:text-5xl text-[#2F2F2F]" style={{ fontFamily: "'DM Serif Display', Georgia, serif" }}>
                {t('chef.title').split(' ').map((word, i) => word === 'Special' ? <span key={i}><span className="italic">{word}</span></span> : <span key={i}>{word} </span>)}
              </h2>
            </TextReveal>
            <TextReveal delay={0.2}><p className="text-[#6B705C] font-light leading-relaxed">{t('chef.description')}</p></TextReveal>
            <TextReveal delay={0.3}><p className="text-[#6B705C] font-light leading-relaxed italic">"{t('chef.quote')}"</p></TextReveal>
            <motion.div className="flex gap-12 pt-6" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.4 }}>
              <div>
                <p className="text-[#C97A2B] text-4xl font-serif mb-1">15+</p>
                <p className="text-[#6B705C] text-xs tracking-[0.15em] uppercase">{t('chef.years')}</p>
              </div>
              <div>
                <p className="text-[#C97A2B] text-4xl font-serif mb-1">100%</p>
                <p className="text-[#6B705C] text-xs tracking-[0.15em] uppercase">{t('chef.handmade')}</p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ChefSection;
